export function isBrowserOffline(): boolean {
  return typeof navigator !== "undefined" && !navigator.onLine;
}

export function isNetworkError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const err = error as { response?: unknown; code?: string; message?: string };
  if (err.response !== undefined) return false;
  const code = err.code ?? "";
  const message = (err.message ?? "").toLowerCase();
  return (
    code === "ERR_NETWORK" ||
    code === "ECONNABORTED" ||
    message.includes("network error") ||
    message.includes("failed to fetch")
  );
}

export function shouldUseCachedData(error: unknown): boolean {
  return isBrowserOffline() || isNetworkError(error);
}
